import { PLATFORM } from "../enums";

enum IpcChannel {
    OpenExternalUrl = "open-external-url",
    UnreadNotifications = "unread-notifications",
    ReadNotifications = "read-notifications",
    OnLogin = "on-login",
    RestartApp = "restart-app",
    AppUpdateDownloaded = "app-update-downloaded",
    SsoFlowInitiated = "sso-flow-initiated",
    EditorInfo = "editor-info",
    RedeemSlackCode = "redeem-slack-code",
    AddToSlack = "add-to-slack",
    QueryEditorInfo = "query-editor-info",
    SetDefaultEditor = "set-default-editor",
    SelectConnectedComponentsWorkspaceFolder = "select-connected-components-workspace-folder",
    OpenFileInEditor = "open-file-in-editor",
    QuerySourceFile = "query-source-file",
    OpenItem = "open-item",
    ShowItemInFolder = "show-item-in-folder",
    OpenPopout = "open-popout",
    OpenMenu = "open-menu",
    HideSuggestedColors = "hide-suggested-colors",
    HideSuggestedTextStyles = "hide-suggested-text-styles",
    SubscribeToImports = "subscribe-to-imports",
    ImportsChange = "imports-change",
    ImportsStarted = "imports-started",
    ClearImports = "clear-imports",
    RetryImport = "retry-import",
    CancelImport = "cancel-import",
    RetryGettingProject = "retry-getting-project",
    RemoveComponentLimitRejection = "remove-component-limit-rejection",
    SetSuggestedResources = "set-suggested-resources",
    ApplyColorOperations = "apply-color-operations",
    ImportStartedFromOldXdIntegration = "import-started-from-old-xd-integration",
    CreateScreen = "CreateScreen",
    CreateScreenVersion = "CreateScreenVersion",
    CreateProjectComponent = "CreateProjectComponent",
    CreateProjectComponentVersion = "CreateProjectComponentVersion",
    CreateProjectComponentVersionV2 = "CreateProjectComponentVersionV2",
    CreateProjectComponentSection = "CreateProjectComponentSection",
    UpdateProjectComponentSection = "UpdateProjectComponentSection",
    UpdateProjectComponentsOrder = "UpdateProjectComponentsOrder",
    CreateProjectColor = "CreateProjectColor",
    CreateStyleguideColor = "CreateStyleguideColor",
    UpdateProjectColor = "UpdateProjectColor",
    UpdateStyleguideColor = "UpdateStyleguideColor",
    CreateProjectTextStyle = "CreateProjectTextStyle",
    CreateStyleguideTextStyle = "CreateStyleguideTextStyle",
    UpdateProjectTextStyle = "UpdateProjectTextStyle",
    UpdateStyleguideTextStyle = "UpdateStyleguideTextStyle",
    CreateStyleguideComponent = "CreateStyleguideComponent",
    CreateStyleguideComponentVersion = "CreateStyleguideComponentVersion",
    CreateStyleguideComponentVersionV2 = "CreateStyleguideComponentVersionV2",
    CreateStyleguideComponentSection = "CreateStyleguideComponentSection",
    UpdateStyleguideComponentSection = "UpdateStyleguideComponentSection",
    UpdateStyleguideComponentsOrder = "UpdateStyleguideComponentsOrder",
    AuthProjectSlack = "AuthProjectSlack",
    AuthStyleguideSlack = "AuthStyleguideSlack",
    InitialImportToBarrelData = "initialImportToBarrelData",
    LoadUrl = "load-url",
    LoadAppUri = "load-app-uri",
    RemindUpdateLater = "remind-update-later",
    PluginUpdateDownloaded = "plugin-update-downloaded",
    InstallPluginUpdate = "install-plugin-update",
    RemindPluginInstallLater = "remind-plugin-install-later",
    CloseAllBanners = "close-all-banners",
    GetMenuTemplateV1 = "get-menu-template-v1",
    MenuTemplateV1 = "menu-template-v1",
    GetMenuTemplateV2 = "get-menu-template-v2",
    MenuTemplateV2 = "menu-template-v2",
    MenuItemClicked = "menu-item-clicked",
    QueryAssetDownloadTarget = "query-asset-download-target",
    AssetsDownloaded = "assets-downloaded",
    DownloadAssets = "download-assets",
    DeleteAssetDownloadTarget = "delete-asset-download-target",
    GetAppMenuParameters = "get-app-menu-parameters",
    GetMenuTemplateV3 = "get-menu-template-v3",
    MenuTemplateV3 = "menu-template-v3",
    ToggleMaximize = "toggle-maximize",
    SetFullScreen = "set-full-screen",
    ContextMenuTemplate = "context-menu-template",
    ContextMenuItemClicked = "context-menu-item-clicked",
    ContextMenuClosed = "context-menu-closed",
    Minimize = "minimize",
    Close = "close",
    UpdateThemeAppearance = "updateThemeAppearance",
    ImportPNGs = "importPNGs",
    UpdateHeaderDragRegions = "updateHeaderDragRegions",
    SetWindowsMaximize = "set-windows-maximize",
    UpdateUseDesktopAppForLinks = "update-use-desktop-app-for-links",
    SetPlatform = "set-platform"
}

export const dynamicIpcChannels = {
    assetDownloadTargets(platform: PLATFORM) {
        return `${platform}-asset-download-targets`;
    }
};

export default IpcChannel;
